import { externalLink } from "@/routes/_constants/external-link";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useBestRateNoticeOfHotelPolicy } from "./hooks";

export const QuestionHotelPolicyBestRateNotice = () => {
	const { isEdited, hasError, hotelID, isShowBestRateNotice, onSetIsShowBestRateNotice } =
		useBestRateNoticeOfHotelPolicy();

	const title = "ベストレート訴求の案内を表示する";
	const guide = `施設ページと予約画面に「このサイトからのご予約が最もお得です」と表示します。英語ページには英語の文が出ます。<br />文面は変更できません。<br />最も安いかどうかを CHILLNN では確認しません。他の予約サイトより高くならないことをご確認のうえ有効にしてください。`;

	const label = "表示する";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			guide={guide}
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<div className="flex flex-col gap-y-4">
					<CheckboxField
						value={isShowBestRateNotice.value}
						label={label}
						handleChange={onSetIsShowBestRateNotice}
						errorMessage={isShowBestRateNotice.error}
					/>
					<p className="text-sm text-zinc-600">
						この機能に関する改善要望は
						<a
							href={externalLink.feedbackSiteUrl(hotelID)}
							target="_blank"
							rel="noopener noreferrer"
							className="text-link-400 underline-offset-4 hover:underline"
						>
							こちら
						</a>
					</p>
				</div>
			}
		/>
	);
};

QuestionHotelPolicyBestRateNotice.displayName = "QuestionHotelPolicyBestRateNotice";
